import { GET_LIST, GET_ONE, CREATE, GetListParams, UPDATE } from "ra-core";

export const customRules = (
  json: Record<string, unknown>,
  method: string,
): Record<string, unknown> | Record<string, unknown>[] => {
  switch (true) {
    case method === GET_ONE:
      return { ...json, id: json._id };
    case method === CREATE:
      return { ...json, id: json._id };
    case method === UPDATE:
      return { ...json, id: json._id };
    case method === GET_LIST:
      return (json as unknown as Record<string, unknown>[]).map((el) => ({
        ...el,
        id: el._id,
      }));
    default:
      return json;
  }
};

export const encodeObjectToQueryParams = (
  obj: Record<string, string | number>,
): string => {
  const queryParams = new URLSearchParams();

  Object.entries(obj).forEach(([key, value]) => {
    if (value != null) {
      queryParams.append(key, String(value));
    }
  });

  return queryParams.toString();
};

export const formatListQueryParams = (
  params: GetListParams,
): Record<string, string | number> => ({
  ...params.pagination,
  ...params.filter,
  ...params.meta,
  sort: params.sort?.field,
  sortOrder: params.sort?.order.toLowerCase(),
  limit: params.pagination?.perPage,
});
